export default "__VITE_ASSET__CJnRRv1X__"